module.exports = __webpack_public_path__ + "img/2-2.42d9a946.jpg";